import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/media";

export default function NewsSection({ news }: { news: NewsItem[] }) {
  const featured = news[0];
  const rest = news.slice(1, 6);
  if (!featured) return null;

  return (
    <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
      <Link
        to={`/news/${featured.id}`}
        className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
      >
        <div className="h-52 w-full overflow-hidden bg-background-200 md:h-64">
          <img
            src={featured.cover}
            alt={featured.title}
            title={`${featured.title} - 91影视资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex flex-1 flex-col p-5">
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <span className="rounded bg-accent-100 px-2 py-0.5 font-medium text-accent-700">
              {featured.category}
            </span>
            <span>{featured.date}</span>
          </div>
          <h3 className="mt-3 text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-600">
            {featured.title}
          </h3>
          <p className="mt-2 line-clamp-2 text-sm text-foreground-500">{featured.excerpt}</p>
          <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
            阅读全文
            <i className="ri-arrow-right-s-line text-lg"></i>
          </span>
        </div>
      </Link>

      <div className="flex flex-col gap-2">
        {rest.map((item) => (
          <Link
            key={item.id}
            to={`/news/${item.id}`}
            className="group flex flex-1 items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
          >
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
              <i className="ri-article-line text-lg"></i>
            </span>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-600">
                {item.title}
              </p>
              <div className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                <span className="rounded bg-background-100 px-1.5 py-0.5">{item.category}</span>
                <span>{item.date}</span>
              </div>
            </div>
            <i className="ri-arrow-right-s-line text-lg text-foreground-300 group-hover:text-primary-500"></i>
          </Link>
        ))}
      </div>
    </div>
  );
}